/**
 * Equipment in Transfers (ClickUp 86bbmcvj4) is waiting on client approval.
 *
 * REACT_APP_FEATURE_EQUIPMENT_TRANSFERS=true or false decides it outright.
 * Left unset, it is on only in dev (REACT_APP_ENVIRONMENT=dev), so it can be
 * tested there while production stays off without any site configuration.
 *
 * The API enforces its own flag (FEATURE_EQUIPMENT_TRANSFERS), so hiding it
 * here is not the only thing keeping it closed.
 *
 * Read on every call rather than once at import, so tests can flip it.
 */
export const isEquipmentTransfersEnabled = (): boolean => {
  const flag = process.env.REACT_APP_FEATURE_EQUIPMENT_TRANSFERS;

  if (flag === 'true') return true;
  if (flag === 'false') return false;

  return process.env.REACT_APP_ENVIRONMENT === 'dev';
};
